import { login, logout, getInfo } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
  state: {
    token: getToken(),
    name: '',
    nickName: '',
    avatar: '',
    roles: [],
    adminId: null,
    /** 当前用户拥有的 ums_resource.url 列表（与鉴权一致，供前端按资源显隐按钮） */
    resourceUrls: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_NICK_NAME: (state, nickName) => {
      state.nickName = nickName || ''
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_ADMIN_ID: (state, id) => {
      state.adminId = id != null && id !== '' ? id : null
    },
    SET_RESOURCE_URLS: (state, urls) => {
      state.resourceUrls = Array.isArray(urls) ? urls : []
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login(username, userInfo.password).then(response => {
          const data = response.data
          const tokenStr = data.tokenHead+data.token
          setToken(tokenStr)
          commit('SET_TOKEN', tokenStr)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          const data = response.data
          if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', data.roles)
          } else {
            reject('getInfo: roles must be a non-null array !')
          }
          commit('SET_ADMIN_ID', data.id)
          commit('SET_RESOURCE_URLS', data.resourceUrls || [])
          commit('SET_NAME', data.username)
          commit('SET_NICK_NAME', data.nickName != null ? data.nickName : '')
          commit('SET_AVATAR', data.icon)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出（不调用下班接口：OP 上班态仅存 Redis，关页/退出均不占「手动下班」；须顶栏开关关闭）
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_ADMIN_ID', null)
          commit('SET_RESOURCE_URLS', [])
          commit('SET_NICK_NAME', '')
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出（同上，不自动下班）
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('SET_ADMIN_ID', null)
        commit('SET_RESOURCE_URLS', [])
        commit('SET_NICK_NAME', '')
        removeToken()
        resolve()
      })
    },

    /**
     * 改库菜单/角色后：整页刷新以重新执行 permission.js 里的 GetInfo + GenerateRoutes（侧栏与路由与 DB 一致）。
     * Redis 资源缓存由后端分配菜单时清理；本地开发可再执行 scripts/clear-redis-ums-cache.sh
     */
    RefreshMenus() {
      return Promise.resolve().then(() => {
        window.location.reload()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js